import { httpInstance } from '@/services/httpInstance';

const getCurrentVersionsService = async () => {
  const endpoint = '/back-office/v1/commerce-version/get-minimum';
  const res = await httpInstance.get(endpoint);
  return res;
};

export default getCurrentVersionsService;
